import React, {Component} from 'react';
import {withRouter} from "react-router-dom";
import renderIf from 'render-if';
import './newGroup.css';
import {routes} from "../../util/config";
import {removeTokenUserStorage, setAlertOnRedux, validRemoveTokenUserStorage} from "../../actions";
import {active, alertLabels, inactive, labels, messages} from "../../util/constants";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faSitemap,faSave,faTimes} from "@fortawesome/free-solid-svg-icons";
import {Button,FormControl, Grid, InputLabel, Paper, TextField} from "@material-ui/core/umd/material-ui.production.min";
import MultiSelectField from "../../components/multiSelect/multiSelect";
import httpHttpsRequest from '../../util/http-request/request';
import { getDataTesisGroupsOptions, getDataTesisSubroupsOptions, postComponentGroupOptions } from '../../util/optionsRequest';

class NewGroup extends Component {

    constructor(props){
        super(props);

        let group = [];
        this.isEdit = false;

        this.state ={
            groupData: [],
            groupSelected : '',
            subgroupSelected : '',
            groupAliasPT : '',
            groupAliasUS : '',
            groupAliasES : '',
            subgroupData : [],
            inactive : 0,
        }

        if (this.props.location != null && this.props.location.state != null &&
            this.props.location.state.isEdit != null && this.props.location.state.isEdit == true) {
            group = this.props.location.state.group;
            this.isEdit = this.props.location.state.isEdit;
        }

        if(this.isEdit){
            let idGroup = group.id_group.substring(0,3);//get id_group from id_subgroup

            this.state = {...this.state,
                groupSelected: {value:idGroup, label: group.group_tesis_label},
                subgroupSelected: {value:group.id_group, label: group.subgroup_tesis_label},
                groupAliasPT : group.group_name_pt,
                groupAliasUS :group.group_name_us,
                groupAliasES : group.group_name_es,
                inactive: group.group_inactive
            };
            this.getDataSubgroups(idGroup);
        }
    };

    componentWillMount(){
        //clean parameters, refresh when the page appears clean
        let stateParams = this.props.location.state;
        let empty = {};
        this.props.history.replace({...stateParams, empty });

        this.getDataGroups();
    };

    getDataGroups=()=>{
        let param = {};

        let http = new httpHttpsRequest(getDataTesisGroupsOptions);
        http.addQueryString(param);

        http.makeRequest().then((data)=>{this.groupsSuccess(JSON.parse(data))})
            .catch((data)=>{this.callBackError(data)})
    };

    getDataSubgroups=(id_group)=>{
        let param = {id_group};

        let http = new httpHttpsRequest(getDataTesisSubroupsOptions);
        http.addQueryString(param);

        http.makeRequest().then((data)=>{this.subgroupsSuccess(JSON.parse(data))})
            .catch((data)=>{this.callBackError(data)})
    };

    saveGroup = () =>{
        let params = {
            id_group : this.state.subgroupSelected.value,
            group_name_pt : this.state.groupAliasPT,
            group_name_us : this.state.groupAliasUS,
            group_name_es : this.state.groupAliasES,
            group_tesis_label : this.state.groupSelected.label,
            subgroup_tesis_label : this.state.subgroupSelected.label,
            group_inactive : active,
        };
        let http = new httpHttpsRequest(postComponentGroupOptions);
        http.addRequestBody(params);
        http.makeRequest().then((data)=>{this.saveGroupSuccess(JSON.parse(data))})
            .catch((data)=>{this.callBackError(data)})
    };

    cancelAction = () =>{
        this.props.history.push({
            pathname: routes.groups
        })
    };

    saveGroupSuccess = (response) =>{
        try{
            if(response != null && response.success == true){
                if(this.isEdit){
                    this.props.history.goBack();
                }else{
                    this.props.history.push({
                        pathname: routes.item,
                        state: { id_group: this.state.subgroupSelected.value, component_group_name: this.state.groupAliasPT} //TODO - VERIFICAR IDIOMA
                    })
                }

                setAlertOnRedux(true,alertLabels.iconSuccess,messages.groupSaved, alertLabels.alertSuccess);
            }else{
                setAlertOnRedux(true,alertLabels.iconError,response.message, alertLabels.alertDanger);
            }
        }catch(err){
            setAlertOnRedux(true,alertLabels.iconError,response.requestErrorDefault, alertLabels.alertDanger);
        }
    };

    groupsSuccess = (response) =>{
        if(response.data && response.data.length > 0){
            this.setState({groupData:response.data});
        }else{
            setAlertOnRedux(true,alertLabels.iconError,messages.getGroupsError, alertLabels.alertDanger);
        }
    };

    subgroupsSuccess = (response) =>{
        try{
            if(response.data && response.data.length > 0){
                this.setState({subgroupData:response.data});
            }else{
                setAlertOnRedux(true,alertLabels.iconInfo,messages.groupNotHaveSubgroup, alertLabels.alertInfo);
            }
        }catch (err){
            setAlertOnRedux(true,alertLabels.iconError,messages.getSubgroupsError, alertLabels.alertDanger);
        }
    };

    callBackError = (response) => {
        try {
            if (validRemoveTokenUserStorage(response.statusCode)) {
                removeTokenUserStorage();
            }
            setAlertOnRedux(true, alertLabels.iconError, messages.requestErrorDefault, alertLabels.alertDanger);
        }catch(err){
            setAlertOnRedux(true, alertLabels.iconError, messages.requestErrorDefault,alertLabels.alertDanger);
        }
    };

    changeGroup = (groupSelected) => {
        if(groupSelected){
            this.setState({groupSelected});
            this.getDataSubgroups(groupSelected.value);
            this.setState({subgroupSelected:[]});
        }
        else{
            this.setState({groupSelected:[]});
        }
    };

    changeSubGroup = (subgroupSelected) => {
        if(subgroupSelected){
            this.setState({subgroupSelected});
        }
        else{
            this.setState({subgroupSelected:[]});
        }
    };

    validShowButtonSave = ()=>{
        if(this.state.groupSelected && this.state.groupSelected.value
                && this.state.subgroupSelected && this.state.subgroupSelected.value
                && this.state.groupAliasPT.length > 0){

            if(this.state.inactive == inactive){
                return (
                    <Button variant="contained"  color="primary" onClick={this.saveGroup}>
                        <FontAwesomeIcon icon={faSave}/> &nbsp;&nbsp;{labels.activeGroup}
                    </Button>
                );
            }else{
                return (
                    <Button variant="contained"  color="primary" onClick={this.saveGroup}>
                        <FontAwesomeIcon icon={faSave}/> &nbsp;&nbsp;{labels.save}
                    </Button>
                );
            }

        }
    };

    validShowButtonCancel = (condition)=>{
        if(condition){
            return (
                <Button variant="contained" style={{marginRight: '2%'}} color="secondary" onClick={this.cancelAction}>
                    <FontAwesomeIcon icon={faTimes}/> &nbsp;&nbsp;{labels.cancel}
                </Button>
            );
        }
    };

    validShowLabelGroup = () =>{
        if (this.state.groupSelected && this.state.groupSelected.value) {
            return <InputLabel htmlFor="multiSelectGroup">{labels.groupSelectedLabel}</InputLabel>;
        } else {
            return <InputLabel htmlFor="multiSelectGroup">{labels.selectGroup}</InputLabel>
        }
    };

    validShowLabelSubGroup = () =>{
        if (this.state.subgroupSelected && this.state.subgroupSelected.value) {
            return <InputLabel htmlFor="multiSelectSubGroup">{labels.subGroupSelectedLabel}</InputLabel>;
        } else {
            return <InputLabel htmlFor="multiSelectSubGroup">{labels.selectSubGroup}</InputLabel>
        }
    };

    validShowTitlePage = () =>{
        if (this.isEdit) {
            return <h1 className='title'>{'\u00A0'} <FontAwesomeIcon icon={faSitemap} />{'\u00A0'} {labels.editionGroup}</h1>;
        } else {
            return <h1 className='title'>{'\u00A0'} <FontAwesomeIcon icon={faSitemap} />{'\u00A0'} {labels.newGroup}</h1>;
        }
    };

    render() {

        return (
            <div className="container ">
                {
                    this.validShowTitlePage()
                }

                {
                    renderIf(this.state.groupData.length > 0)
                    (

                        <Grid item xs={12} container spacing={8}>
                            <Grid item xs={6}>
                                <Paper className={styles.paper}>
                                    <div className={'div-paper'}>
                                        {this.validShowLabelGroup()}
                                        <MultiSelectField id="multiSelectGroup" data={this.state.groupData} multi={false} handleSelectChange={this.changeGroup}
                                                          valuesSelected={this.state.groupSelected} placeHolder={labels.selectGroupPlaceHolder}
                                                          disabled={this.isEdit}/>
                                    </div>
                                    {
                                        renderIf(this.state.groupSelected && this.state.groupSelected.value && this.state.subgroupData.length > 0 )
                                        (
                                            <div className={'div-paper'}>
                                                {this.validShowLabelSubGroup()}
                                                <MultiSelectField id="multiSelectSubGroup" data={this.state.subgroupData} multi={false} handleSelectChange={this.changeSubGroup}
                                                                  valuesSelected={this.state.subgroupSelected} placeHolder={labels.selectSubGroupPlaceHolder}
                                                                  disabled={this.isEdit}/>
                                            </div>
                                        )
                                    }
                                    <div className={'div-btn'}>
                                        {this.validShowButtonCancel(!(this.state.subgroupSelected && this.state.subgroupSelected.value &&
                                            this.state.groupSelected && this.state.groupSelected.value))}
                                    </div>
                                </Paper>
                            </Grid>
                            <Grid item xs={6}>
                                <Paper className={styles.paper}>
                                    {
                                        renderIf(this.state.subgroupSelected && this.state.subgroupSelected.value &&
                                            this.state.groupSelected && this.state.groupSelected.value)
                                        (
                                            <div>
                                                <div className={'div-paper'}>
                                                    <FormControl className="formControlGroup">
                                                        <TextField
                                                            label={labels.groupAliasPT}
                                                            value={this.state.groupAliasPT}
                                                            onChange={(input)=>{this.setState({groupAliasPT:input.target.value})}}
                                                        />
                                                    </FormControl>
                                                </div>
                                                <div className={'div-paper'}>
                                                    <FormControl className="formControlGroup">
                                                        <TextField
                                                            label={labels.groupAliasUS}
                                                            value={this.state.groupAliasUS}
                                                            onChange={(input)=>{this.setState({groupAliasUS:input.target.value})}}
                                                        />
                                                    </FormControl>
                                                </div>
                                                <div className={'div-paper'}>
                                                    <FormControl className="formControlGroup">
                                                        <TextField
                                                            label={labels.groupAliasES}
                                                            value={this.state.groupAliasES}
                                                            onChange={(input)=>{this.setState({groupAliasES:input.target.value})}}
                                                        />
                                                    </FormControl>
                                                </div>

                                                <div className={'div-btn'}>
                                                    {this.validShowButtonCancel((this.state.subgroupSelected && this.state.subgroupSelected.value &&
                                                        this.state.groupSelected && this.state.groupSelected.value))}
                                                    {this.validShowButtonSave()}
                                                </div>
                                            </div>
                                        )

                                    }
                                </Paper>
                            </Grid>

                        </Grid>

                    )
                }

            </div>
        )
    }
}
const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: theme.spacing.unit,
        textAlign: 'center',
        color: theme.palette.text.secondary,
        margin: '2%',
    },
});


export default withRouter(NewGroup);


// WEBPACK FOOTER //
// ./src/containers/cst_group/newGroup.js